import { get } from "../../../utils/object-helpers";

$ {
    const textualDisplays = get(input, "textualDisplays", []);
}

<for|textualDisplay| of=textualDisplays>
    <div class="str-text-with-separator">
        <span class="str-text-with-separator__separator">&nbsp;·&nbsp;</span>
        <span class="str-text-with-separator__text">
            <str-textual-display ...textualDisplay />
        </span>
    </div>
</for>
